import {core} from './core';
core();

/*
* Functionalities that are needed only in unicef main site, not in unicef walk
*/

//Close button for details elements (ie in mobile language navigation)
const detailsCloseButtons = document.querySelectorAll('.js-close-details');
if (detailsCloseButtons.length) {
  detailsCloseButtons.forEach(button => {
    button.addEventListener('click', () => {
      const details = button.closest('details');
      details.removeAttribute('open');
    })
  });
}

//Actual donation form on /lahjoitus/ page
const donationForm = document.querySelector('.js-donation');
if (donationForm) {
  import('./modules/donation')
    .then(({default: Donation}) => {
      const donation = new Donation();
      donation.init();
    })
}

//Single donation checkout form
const checkoutContainer = document.querySelector('.js-donation-checkout');
if (checkoutContainer) {
  import('./modules/donation-checkout')
    .then(({default: DonationCheckout}) => {
      const donationCheckout = new DonationCheckout(checkoutContainer);
      donationCheckout.init();
    })
}

const newsArchive = document.querySelector('.js-news-archive');
if (newsArchive) {
  import('./modules/toggleVisibleItems')
    .then(({default: toggleVisibleItems}) => toggleVisibleItems(newsArchive))
}

const educationMaterials = document.querySelector('[data-material-guide]');
if (educationMaterials) {
  import('./modules/education-materials')
    .then(({ default: EducationMaterials }) => {
      const eM = new EducationMaterials(educationMaterials);
      eM.init();
    });
}

const contactsSearch = document.querySelector('.js-contact-us__search');
if (contactsSearch) {
  import('./modules/getContacts')
    .then(({default: getContacts}) => getContacts(contactsSearch))
}
